import { styled } from "@mui/material/styles";
import { TreeView } from "@mui/lab";
import { treeItemClasses } from "@mui/lab/TreeItem";

export const StyledTreeView = styled(TreeView, {
  shouldForwardProp: prop => prop !== "compact",
})<{ compact?: boolean }>`
  flex: 0;
  width: 100%;
  max-height: calc(100vh - 204px);
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: none;
  border-top: 1px solid #ebebf7;
  padding-top: 8px;

  ${({ compact }) =>
    compact
      ? `
    & .${treeItemClasses.group} {
      margin-left: 6px;
      padding-left: 10px;
    }

    & .${treeItemClasses.content} {
      padding-left: 2px;
      padding-right: 4px;
    }

    & .${treeItemClasses.iconContainer} {
      width: 18px;
      margin-right: 0;
    }

    & .${treeItemClasses.label} {
      min-width: 0;
      overflow: hidden;
    }
  `
      : ""}
`;
